import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-services',
	templateUrl: './services.component.html',
	styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit {

	constructor() { }

	ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/services/services.component.ts